var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    d: "M10.287 23.275a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429M18.001 23.275a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429M14.367 6.2A6.858 6.858 0 1 0 3.43 13.213M7.716 7.88l2.571-2.57M11.144 16.435v-1.714H8.573a3.43 3.43 0 0 0-3.429 3.428v3.429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    d: "M23.144 21.56v-8.57a1.714 1.714 0 0 0-1.714-1.715h-8.572a1.714 1.714 0 0 0-1.714 1.714v3.429"
  })));
};
export default SvgDelivery;